/**
* In Dashboard function is used to dispaly the Parents,Physician,Appointment module counts in UI
**/
import { useState, useEffect } from 'react';
import ApiService from './../../../services/ApiService';
import DashboardChildren from '../../../shared/components/Children';
import Physician from "../../../shared/components/Physician";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Dashboard() {	

	//Intial state declaration
	const [data,setData]=useState({});
	const [users,setUserData]=useState({});
	const [param, setParam] = useState({ page: 0, limit: 10 });
	console.log("users : ",users.counts);
	const { t } = useTranslation();
	
	//components initialize function and api handling
	useEffect(()=>{
	   (async()=>{
		    var response=await ApiService.getHospitalAdminDashboard();
			console.log("count : ",response.data);
			if(response.status===200)
				setData(response.data);	 
	   })();
   },[]);


       //components initialize function and api handling
	   useEffect(() => {
        (async () => {
          try {
            // Fetch the physician list
            const response = await ApiService.physicianList(param);
            console.log("Response Data from physicianList:", response.data);
      
            // Fetch users list with hospital and physician
            const userResponse = await ApiService.getUsersList({ list: ["hospital", "physician"] });
            console.log("Original Physician List : ", response.data);
      
            if (userResponse.status === 200) {
              const { hospital = [], physician = [] } = userResponse.data;
              const userRole = localStorage.getItem("role"); // Retrieve role from localStorage or context
              console.log("Role : ", userRole);
      
              let allowedHospitalId = null;
      
              // Check role and extract the hospital ID
              if (parseInt(userRole) === 4 && hospital.length > 0) {
                allowedHospitalId = hospital[0]?.id; // Get the first hospital ID (modify as needed for multiple hospitals)
                console.log("Allowed Hospital ID : ", allowedHospitalId);
              }
      
              // Filter `filteredPhysicians` based on the hospital condition
              const filteredPhysicians = physician.filter(
                (physicianItem) =>
                  !physicianItem.hospital || // Allow if hospital is empty or null
                  physicianItem.hospital === allowedHospitalId // Allow if hospital matches the allowed hospital ID
              );
              console.log("Filtered Physicians:", filteredPhysicians);
      
              // Extract the accounts from `filteredPhysicians`
              const allowedAccounts = filteredPhysicians.map((item) => item.account);
      
              // Ensure `response.data.details` is accessed as the physician list
              const physicianList = Array.isArray(response.data.details) ? response.data.details : [];
              console.log("Processed Physician List:", physicianList);
      
              // Filter `physicianList` for role 4
              if (parseInt(userRole) === 4) {
                const updatedPhysicianList = physicianList.filter(
                  (physicianItem) =>
                    allowedAccounts.includes(physicianItem.account) && // Account must be present in both
                    (!physicianItem.hospital || // Hospital is empty/null
                      physicianItem.hospital.trim() === "" || // Hospital is empty string
                      physicianItem.hospital === allowedHospitalId) // Hospital matches allowedHospitalId
                );

                 // Include count and message along with the filtered physician details
                const updatedPhysicianListWithMeta = {
                    details: updatedPhysicianList,
                    counts: updatedPhysicianList.length.toString(), // Set the count based on the filtered list
                    message: response.data.message, // Include the original message
                };
      
                // Update the state with the filtered data
                //setUser({ ...userResponse.data, physician: filteredPhysicians });
                setUserData(updatedPhysicianListWithMeta);
                console.log("Mapped and Filtered Physician List : ", updatedPhysicianListWithMeta);
                return; // Stop execution for role 4 after setting state
              }
            }
      
            // For other roles, set the physician list as is
            //setUserData(response.data);
          } catch (error) {
            console.error("Error fetching user or physician list:", error);
          }
        })();
      }, [param]);

	return (
		<main id="main" className="main">
			<div className="pagetitle">
				<h1>{t('sidebar.dashboard')}</h1>
			</div>
			<section className="dashboard">
				<div className="row nav" role="tablist">
					<div className="col-xxl-3 col-md-6 active" id="nav-01-tab" data-bs-toggle="tab" data-bs-target="#nav-01" type="button" role="tab" aria-controls="nav-01" aria-selected="true">
						<div className="card info-card admin-dashboard-card" >
							<div className="card-body">
								<div className="card-text ps-0 pe-4 d-flex align-items-center justify-content-between">
									<h3>{t('sidebar.children')}</h3>
									<h2>{data?.count?.member_profiles !== "0" ? data?.count?.member_profiles : '--'}</h2>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xxl-3 col-md-6" id="nav-02-tab" data-bs-toggle="tab" data-bs-target="#nav-02" type="button" role="tab" aria-controls="nav-02" aria-selected="false">
						<div className="card info-card admin-dashboard-card" >
							<div className="card-body">
								<div className="card-text ps-0 pe-4 d-flex align-items-center justify-content-between">
									<h3>{t('sidebar.physician')}</h3>
									<h2>{users?.counts !== "0" ? users?.counts : '--'}</h2>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xxl-3 col-md-6" id="nav-03-tab" data-bs-toggle="tab" data-bs-target="#nav-04" type="button" role="tab" aria-controls="nav-04" aria-selected="false">
						<Link to='/hospital/admin/appointments'>
							<div className="card info-card admin-dashboard-card">
								<div className="card-body">
									<div className="card-text ps-0 pe-4 d-flex align-items-center justify-content-between">
										<h3>{t('sidebar.appointments')}</h3>
										<h2>{data?.count?.appointment_counts !== "0" ? data?.count?.appointment_counts : '--'}</h2>
									</div>
								</div>
							</div>
						</Link>
					</div>
					{/* <!-- Tab Content --> */}
					<div className="tab-content">			
						<div className="tab-pane fade show active" id="nav-01" role="tabpanel" aria-labelledby="nav-01-tab">
							<DashboardChildren data={'dashboard'}/>
						</div>

						<div className="tab-pane fade show" id="nav-02" role="tabpanel" aria-labelledby="nav-02-tab">
							<Physician data={'dashboard'}/>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
}

export default Dashboard;
